import React from "react";
import clsx from "clsx";
import { CircularProgress } from "@mui/material";

export const Button = ({
  color = "default",
  size = "auto",
  disable = false,
  label = "Login",
  onClick,
  className = "",
  loading = false,
  type = "button",
  icon,
  TLoading,
  ...props
}) => {
  const sizeClasses = {
    small: "w-[88px] h-[35px]",
    medium: "w-[90px] h-[25px]",
    large: "h-[40px] w-full",
    extraLarge: "w-[133px] h-[33px]",
    auto: `${!icon ? "px-2" : "pr-1"}`,
  };

  const sizeClassesImg = {
    small: "min-w-[40px] h-[35px]",
    medium: "min-w-[41px] h-9",
    large: "h-10 px-8",
    auto: "min-w-[41px] h-[38px]",
  };

  const colorClasses = {
    // default: "bg-[#00B6CE] text-[#FFFFFF] text-[14px] font-medium",
    default: "bg-[#FF702B] text-[#FFFFFF] text-[14px] font-medium",
    primary:
      "bg-[#34C759] border border-[#50BF62] text-[#FFFFFF] rounded-[100px]",
    primaryLight:
      "bg-[#DEFDDE] border border-[#50BF62] text-[#50BF62] rounded-[13px]",
    secondary:
      "bg-yellowBackground border !border-yellowText text-yellowText rounded-[9px]",
    outlinedGreen:
      "bg-greenBackground border-[0.5px] !border-greenText !text-greenText !rounded-[9px] font-light",
    outlinedBlue:
      "bg-white border !border-secondary text-secondary rounded-[4px]",
    outlinedRed:
      "bg-redBackground border !border-redText text-redText rounded-[4px]",
  };

  const statusColorMap = {
    success: "outlinedGreen",
    active: "outlinedGreen",
    approved: "outlinedGreen",
    completed: "outlinedGreen",
    send: "outlinedGreen",
    submitted: "primaryLight",
    pending: "secondary",
    inprogress: "secondary",
    processing: "secondary",
    pending_tmid: "secondary",
    sent_to_customer: "secondary",
    "in-active": "outlinedRed",
    blocked: "outlinedRed",
    fail: "outlinedRed",
    failed: "outlinedRed",
    rejected: "outlinedRed",
    sent: "primaryLight",
    delivered: "primaryLight",
    accepted: "primaryLight",
    message_delivered: "primaryLight",
    send_message_success: "primaryLight",
    message_read: "primaryLight",
    message_click: "primaryLight",
    declined: "outlinedRed",
    unrechable_user: "outlinedRed",
    send_message_failure: "outlinedRed",
    sent_to_customer: "secondary",
  };

  const dotColorMap = {
    primary: "bg-greenText",
    primaryLight: "bg-greenText",
    secondary: "bg-yellowText",
    outlinedRed: "bg-redText",
    outlinedGreen: "bg-greenText",
    outlinedBlue: "bg-blue-500",
    default: "bg-gray-400",
  };

  const lowerLabel = label?.toLowerCase();
  const statusColorKey = statusColorMap[lowerLabel];
  const finalColorClass = colorClasses[statusColorKey] || colorClasses.default;
  const dotColor = dotColorMap[statusColorKey];

  return (
    <button
      type={type}
      className={clsx(
        "flex items-center justify-center gap-1 rounded-lg z-10 shadow-custom2",
        sizeClasses[size],
        finalColorClass,
        disable || loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
        className
      )}
      onClick={onClick}
      disabled={disable || loading}
      {...props}
    >
      {icon && (
        <div
          className={clsx(
            "flex items-center justify-center rounded-l-md",
            sizeClassesImg[size]
          )}
          style={{
            clipPath: "polygon(0px -50px, 100% 18px, 78% 101%, 0px 101%)",
            backgroundColor: "#FFF",
          }}
        >
          <img src={icon} alt="icon" className="w-[18px] h-[18px]" />
        </div>
      )}
      {loading ? (
        <div className="inset-0 z-50 flex items-center justify-center bg-opacity-50">
          <CircularProgress size="20px" sx={{ color: "#FFF" }} />
        </div>
      ) : (
        <div className="m-auto flex items-center gap-[5px]">
          {dotColor && (
            <span
              className={`inline-block w-2.5 h-2.5 rounded-full ${dotColor}`}
            />
          )}
          {TLoading && <CircularProgress size="20px" sx={{ color: "#FFF" }} />}
          {label}
        </div>
      )}
    </button>
  );
};

export default Button;
